<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>
<script>
	import {
		getBaseData
	} from './api/main'
	export default {
		methods: {
			saveState() {
				sessionStorage.setItem('state', JSON.stringify(this.$store.state))
			}
		},
		mounted() {
			window.addEventListener('unload', this.saveState);
			let username = sessionStorage.getItem('username')
			console.log(username)
			if (username == null || username == "" || username == undefined) {
				this.$router.push('/Login');
			}
			
		}
	}
</script>
<style lang="less">

</style>
